import React from "react";
import { Button } from "@mui/material";

const NavigationButtons = ({
  classes,
  isDisabled,
  onPrevious,
  onNext,
  position,
}) => {
  return (
    <div className={classes.mainStyle}>
      {!isDisabled("back") && (
        <Button
          className={classes.mButtonStyle}
          disabled={isDisabled("back")}
          onClick={onPrevious}
        >
          Previous Document
        </Button>
      )}

      {position === "bottom" && !isDisabled("next") && (
        <Button
          className={classes.mButtonStyle}
          disabled={isDisabled("next")}
          onClick={onNext}
        >
          Next Document
        </Button>
      )}
    </div>
  );
};

export default NavigationButtons;
